// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__28pE7","logo":"Footer_logo__TuCzv","short":"Footer_short__1jP1S","copyright":"Footer_copyright__2-Gns"};